import { InjectionToken, Type } from '@angular/core';
import { Observable } from 'rxjs';

export interface EntityFacade<T = unknown> {
  loaded$: Observable<boolean>;
  allEntities$: Observable<T[]>;
  selectedEntity$?: Observable<T | undefined>;

  load(): Observable<T[]>;
  addEntity?(entity: T): void;
  editEntity(entity: T): void;
  deleteEntity(entity: T): void;
  editOrAddSuccess?(): Observable<unknown>;
}

export interface EntityCardChip {
  image: string | null;
  name: string;
}

export interface EntityCard<T = unknown> {
  id: string | number;
  image: string | null;
  imageFit?: 'cover' | 'contain';
  avatar: string | null;
  title: string;
  subtitle: string;
  description: string;
  chips: EntityCardChip[];
  raw: T;
}

export type EntityToCardFn<T = unknown> = (entity: T) => EntityCard<T>;

export const ENTITY_FACADE = new InjectionToken<EntityFacade>('ENTITY_FACADE');
export const ENTITY_FORM_COMPONENT = new InjectionToken<Type<unknown>>(
  'ENTITY_FORM_COMPONENT',
);
export const ENTITY_TO_CARD_MAPPER = new InjectionToken<EntityToCardFn>(
  'ENTITY_TO_CARD_MAPPER',
);
export const CAN_ADD = new InjectionToken<boolean>('CAN_ADD');
export const CAN_EDIT = new InjectionToken<boolean>('CAN_EDIT');
export const CAN_DELETE = new InjectionToken<boolean>('CAN_DELETE');
